export const promoStripePageInfos = [
    // {url: /^\/$/, returningUsers: false, currentCustomersOnly: true,},
    // {url: /^\/pricing$/, returningUsers: true},
    // {url: /^\/pricing-b$/, returningUsers: true},
    // {url: /^\/pos-hardware$/, returningUsers: true},
    // {url: /^\/business-types\/retail-pos$/, returningUsers: false},
    // {url: /^\/business-types\/restaurant-pos$/, returningUsers: false},
    // {url: /^\/business-types\/bar-pos$/, returningUsers: false},
    // {url: /^\/business-types\/quick-service-restaurant-pos$/, returningUsers: false},
    // {url: /^\/pos-system$/, returningUsers: false},
    // {url: /^\/perfect-pos-solution$/, returningUsers: false},
    // {url: /^\/perfect-ipad-pos$/, returningUsers: false},
    // {url: /^\/perfect-pos-solution-b$/, returningUsers: true},
    // {url: /^\/welcome-to-shopkeep$/, returningUsers: true},
    // {url: /^\/pos\/features$/, returningUsers: true},
    // {url: /^\/pos-software$/, returningUsers: true},
    // {url: /^\/ipad-pos$/, returningUsers: true},
    // {url: /^\/blog/, returningUsers: false},
    // {url: /^\/blog\/(?!talking-shop)/, returningUsers: false}, //regex to match all blog pages except those that contain /blog/talking-shop
];


export function promoStripeInfoForPath(path){
    for (let i = 0; i < promoStripePageInfos.length; i++) {
        const pageInfo = promoStripePageInfos[i];
        if (pageInfo.url.test(path)) {
            return pageInfo;
        }
    }
    return false;
}

